import RootStore from "store/rootStore";

const saveHandler = (
  store: RootStore,
  appFetch: any,
  history: any,
  userLogin?: string | null
) => {
  const {
    saveLabelisations,
    isError,
    errorMessage,
  } = store.labelerSegmentationStore;

  const {
    setIsSnackbarOpen,
    setMessageSnackBar,
    setVariantSnackBar,
  } = store.labelerSegmentationUiStore;

  saveLabelisations(appFetch, userLogin).then((data: any) => {
    const saved = data && !isError;
    setMessageSnackBar(saved ? "labelisation sauvegardée" : errorMessage);
    setVariantSnackBar(saved ? "success" : "error");
    setIsSnackbarOpen(true);
    setTimeout(() => {
      setIsSnackbarOpen(false);
      setMessageSnackBar("");
      saved && goToNextImage(store, history);
    }, 1500);
  });
};

const goToNextImage = (store: RootStore, history: any) => {
  const { batch, numImage } = store.labelerSegmentationStore;

  const { labeledImages, images } = store.labelerSegmentationStore;

  const {
    setAlertDialogText,
    setAlertDialogCallback,
    setAlertDialogCloseCallback,
    setOpenAlertDialog,
  } = store.labelerSegmentationUiStore;

  const finished = labeledImages.length === images.length;
  const isLastImage = numImage == images.length - 1;

  if (finished && isLastImage) {
    setAlertDialogText("La labellisation de ce lot est terminée");
    setAlertDialogCallback(() => {
      handleFinishLabeling(history);
    });
    setAlertDialogCloseCallback(() => {
      handleFinishLabeling(history);
    });
    setOpenAlertDialog(true);
  } else {
    history.push(`/labelerSegmentation/${batch.id}/${Number(numImage) + 1}`);
  }
};

const handleFinishLabeling = (history: any) => {
  history.push("/batches/0?sort=createdDate,desc");
};

export default saveHandler;
